import { Box } from 'components/Box';
import { Tag } from 'components/Tag';
import { CmsApiTag } from 'modules/cms/api/types/CmsApiTag';

type Props = {
  homePageUrl: string;
  tags: Array<CmsApiTag>;
};

export function CmsTagList({ homePageUrl, tags }: Props) {
  return (
    <Box data-qa-id="tags" display="flex" m="-6px">
      {tags.map((tag) => (
        <Tag
          key={tag.slug}
          component={homePageUrl && 'a'}
          disabled={!homePageUrl && 'disabled'}
          data-qa-id="tag-link"
          href={homePageUrl ? `/${homePageUrl}?tags.slug=${tag.slug}&pq=` : ''}
          m="6px"
        >
          {tag.tag}
        </Tag>
      ))}
    </Box>
  );
}
